import { useNavigate } from 'react-router-dom';

import InfoContent from './components/InfoContent';

import { NavBar } from '@/components';
import ROUTES from '@/router/routes';
import { GENERICS_WORDS } from '@/utils';

export const InfoGoldDate = () => {
  const navigate = useNavigate();
  return (
    <NavBar
      mobile={{
        centerContent: {
          title: GENERICS_WORDS.goldDate,
        },
        leftContent: {
          backAction: () => {
            navigate(ROUTES.goldDate.home);
          },
        },
      }}
    >
      <div className="px-6 pt-4 ">
        <InfoContent />
      </div>
    </NavBar>
  );
};
